export const translations = {
  nav: {
    home: { cs: "Domů", en: "Home" },
    about: { cs: "O nás", en: "About Us" },
    services: { cs: "Služby", en: "Services" },
    booking: { cs: "Kalendář", en: "Book a Meeting" },
    faq: { cs: "FAQ", en: "FAQ" },
    contact: { cs: "Kontakt", en: "Contact" },
    matrix: { cs: "Finanční analýza", en: "Financial Analysis" },
    bookBtn: { cs: "Rezervovat schůzku", en: "Book a Meeting" },
  },
  hero: {
    badge: { cs: "Pojištění · Investice · Hypotéky", en: "Insurance · Investments · Mortgages" },
    headline: { cs: "Pojištění a finance lidsky a bez starostí", en: "Insurance and Finance Made Human and Hassle-Free" },
    headlineLine1: { cs: "Pojištění a finance", en: "Insurance and finance" },
    headlineLine2: { cs: "lidsky a bez starostí", en: "without the hassle" },
    subtext: {
      cs: "Jsme dva parťáci – Raffaele Zirone a Ondřej Šenfeld. V oblasti pojištění hrdě spolupracujeme s Allianz, u hypoték a úvěrů vybíráme ze všech bank na trhu.",
      en: "We're two partners – Raffaele Zirone and Ondřej Šenfeld. For insurance we proudly team up with Allianz; for mortgages and loans we pick from every bank on the market.",
    },
    ctaPrimary: { cs: "Rezervovat schůzku", en: "Book a Meeting" },
    ctaAnalysis: { cs: "Spustit Finanční analýzu", en: "Run Financial Analysis" },
    ctaSecondary: { cs: "Co umíme", en: "What We Do" },
    trust1: { cs: "Všechny schůzky zdarma", en: "All meetings free" },
    trust2: { cs: "Férové a srozumitelné poradenství", en: "Honest, easy-to-understand advice" },
    trust3: { cs: "Osobně nebo online", en: "In person or online" },
    cardChip: { cs: "30 minut · zdarma · nezávazně", en: "30 min · free · no strings" },
    cardTitle: { cs: "Kafe na nás, rady zdarma", en: "Coffee's on us, advice is free" },
    cardText: {
      cs: "Pojďte si promluvit o tom, co vás trápí. Třeba zjistíte, že je to jednodušší, než jste mysleli.",
      en: "Come talk about what's on your mind. You might find it's simpler than you thought.",
    },
  },
  stats: [
    { v: "100 %", l: { cs: "nezávislost u hypoték", en: "independence on mortgages" } },
    { v: "19+", l: { cs: "bank a institucí", en: "banks & institutions" } },
    { v: "60 s", l: { cs: "Finanční analýza zdarma", en: "free Financial Analysis" } },
  ],
  statsLive: { cs: "Kancelář Česká Lípa · online", en: "Česká Lípa office · online" },
  zat: {
    kicker: { cs: "ZIRSEN · FINANČNÍ ANALÝZA", en: "ZIRSEN · FINANCIAL ANALYSIS" },
    heading: { cs: "Finanční analýza", en: "Financial Analysis" },
    sub: {
      cs: "Za 60 sekund zjistíte, jak na tom vaše finance jsou. Pět pilířů, pár kliknutí a hned vidíte, kde vám utíkají peníze — od pojištění přes investice a spoření až po hypotéku a úvěry.",
      en: "In 60 seconds you'll know where your finances stand. Five pillars, a few clicks, and you'll instantly see where your money leaks — from insurance and investments to your mortgage and loans.",
    },
    chips: [
      { cs: "60 sekund", en: "60 seconds" },
      { cs: "5 pilířů financí", en: "5 financial pillars" },
      { cs: "Okamžitý výsledek", en: "Instant result" },
    ],
    cta: { cs: "Spustit Finanční analýzu", en: "Run Financial Analysis" },
    note: { cs: "Zdarma · bez registrace · výsledky společně probereme na schůzce", en: "Free · no sign-up · we'll go through the results together in a meeting" },
  },
  cookies: {
    title: { cs: "Cookies? Jasně.", en: "Cookies? Sure." },
    text: {
      cs: "Používáme jen nezbytné cookies k fungování webu a — s vaším souhlasem — analytické pro jeho zlepšování. Žádný prodej dat, žádná špionáž.",
      en: "We only use essential cookies to run the site and — with your consent — analytics to improve it. No data selling, no spying.",
    },
    acceptAll: { cs: "Přijmout vše", en: "Accept all" },
    reject: { cs: "Odmítnout", en: "Reject" },
    settings: { cs: "Nastavení", en: "Settings" },
    save: { cs: "Uložit výběr", en: "Save choice" },
    necessary: { cs: "Nezbytné", en: "Necessary" },
    analytics: { cs: "Analytické", en: "Analytics" },
    marketing: { cs: "Marketingové", en: "Marketing" },
    alwaysOn: { cs: "Vždy zapnuté", en: "Always on" },
    privacyLink: { cs: "Ochrana osobních údajů", en: "Privacy policy" },
  },
  about: {
    badge: { cs: "Kdo jsme", en: "Who We Are" },
    heading: { cs: "Dva partneři. Jeden cíl – vaše klidné finance.", en: "Two partners. One goal – your financial peace of mind." },
    bio: {
      cs: "Zirsen jsme založili spolu, protože věříme, že finanční poradenství má být osobní, srozumitelné a vždy na straně klienta. Raffaele má s financemi delší zkušenost, Ondřej přinesl novou energii. Oba se věnujeme pojištění, financím i investicím. Žádný prodejní tlak – jen poctivé poradenství, které dává smysl.",
      en: "We founded Zirsen together because we believe financial advice should be personal, clear and always on the client's side. Raffaele brings years of experience, Ondřej fresh energy. We both cover insurance, finance and investments. No sales pressure – just honest advice that makes sense.",
    },
    partner1Name: "Raffaele Zirone",
    partner1Title: { cs: "Spoluzakladatel · Pojištění, finance, investice", en: "Co-Founder · Insurance, Finance, Investments" },
    partner1Bio: {
      cs: "Ve financích se pohybuje řadu let. Zaměřuje se na investice a financování bydlení a vždy klade důraz na srozumitelnost a dlouhodobou strategii klienta.",
      en: "He has spent many years in finance. He focuses on investments and home financing, always emphasizing clarity and the client's long-term strategy.",
    },
    partner2Name: "Ondřej Šenfeld",
    partner2Title: { cs: "Spoluzakladatel · Pojištění, finance, investice", en: "Co-Founder · Insurance, Finance, Investments" },
    partner2Bio: {
      cs: "Specializuje se na pojištění a detailní analýzu smluv. Klientům pomáhá odhalit skrytá rizika a nastavit krytí přesně podle jejich situace.",
      en: "He specializes in insurance and detailed policy analysis. He helps clients uncover hidden risks and set coverage precisely to their situation.",
    },
    stats: [
      { type: "counter", value: 2, suffix: "", label: { cs: "Parťáci", en: "Partners" }, testid: "stat-partners" },
      { type: "counter", value: 200, suffix: "+", label: { cs: "Vypitých káv s klienty", en: "Coffees Drunk with Clients" }, testid: "stat-coffees", icon: "coffee" },
      { type: "text", value: { cs: "Česká Lípa", en: "Česká Lípa" }, label: { cs: "Naše kancelář", en: "Our Office" }, testid: "stat-office", icon: "pin" },
    ],
    officeBadge: { cs: "Kde nás najdete", en: "Where to Find Us" },
    officeAddress: { cs: "Hrnčířská 2456, 470 01 Česká Lípa 1", en: "Hrnčířská 2456, 470 01 Česká Lípa 1" },
    officeIco1: { cs: "IČO: 19739842 — Ondřej Šenfeld", en: "Business ID: 19739842 — Ondřej Šenfeld" },
    officeIco2: { cs: "IČO: 11746858 — Raffaele Zirone", en: "Business ID: 11746858 — Raffaele Zirone" },
  },
  services: {
    badge: { cs: "Na čem nás najdete", en: "What We Do" },
    heading: { cs: "Pojištění je naše parketa. Ale vyřešíme i zbytek.", en: "Insurance Is Our Home Turf. But We Handle the Rest Too." },
    subtext: {
      cs: "Hlavně se staráme o to, aby bylo pojištěné všechno důležité – vy, vaše rodina, bydlení i auto. Řešíme i pojištění firem a podnikatelů. K tomu přidáme investice a hypotéky, ať to dává smysl dohromady.",
      en: "Above all, we make sure everything important is insured – you, your family, home and car, plus businesses and entrepreneurs. We add investments and mortgages so it all makes sense together.",
    },
    mainFocus: { cs: "Exkluzivně s Allianz", en: "Exclusive with Allianz" },
    pillars: [
      {
        id: "insurance",
        featured: true,
        title: { cs: "Pojištění na míru", en: "Tailored Insurance" },
        desc: {
          cs: "Životní pojištění, majetek, vozidla i pojištění firem a podnikatelů – v exkluzivní spolupráci s Allianz. Projdeme vaše stávající smlouvy, ukážeme, kde platíte zbytečně moc, a nastavíme krytí přesně podle vašeho života i podnikání.",
          en: "Life, property and vehicle insurance, plus coverage for businesses – in exclusive cooperation with Allianz. We review your policies, show where you overpay and set coverage around your life and business, exactly as it should be.",
        },
        tags: [
          { cs: "Životní pojištění", en: "Life Insurance" },
          { cs: "Majetek a domácnost", en: "Property & Home" },
          { cs: "Vozidla", en: "Vehicles" },
          { cs: "Firmy a podnikatelé", en: "Businesses & Entrepreneurs" },
        ],
      },
      {
        id: "investments",
        title: { cs: "Investice a rezervy", en: "Investments & Reserves" },
        desc: {
          cs: "Peníze stranou nemají ležet ladem. Vybíráme ze všech institucí na trhu a sestavíme plán, jak si budovat rezervu, zhodnocovat úspory a zajistit se na důchod – konzervativně nebo odvážněji, podle vás.",
          en: "Your savings shouldn't sit idle. We pick from every institution on the market and build a plan for your reserve, savings and retirement – conservative or bolder, your call.",
        },
        tags: [
          { cs: "Finanční rezerva", en: "Safety Net" },
          { cs: "Penzijní připojištění", en: "Pension Savings" },
          { cs: "Dlouhodobé spoření", en: "Long-term Saving" },
        ],
      },
      {
        id: "mortgages",
        title: { cs: "Hypotéky a úvěry", en: "Mortgages & Loans" },
        desc: {
          cs: "Bydlení bez starostí a papírování. Porovnáme nabídky všech bank na trhu, vyjednáme lepší sazbu a s formalitami vám pomůžeme od začátku do konce.",
          en: "Housing without stress and paperwork. We compare offers from all banks, negotiate a better rate and handle the formalities from start to finish.",
        },
        tags: [
          { cs: "Koupě bydlení", en: "Home Purchase" },
          { cs: "Refinancování", en: "Refinancing" },
        ],
      },
    ],
    cta: { cs: "Probrat nad kávou", en: "Talk It Over a Coffee" },
  },
  partners: {
    badge: { cs: "Partneři", en: "Partners" },
    heading: { cs: "S kým spolupracujeme", en: "Who We Work With" },
    subtext: {
      cs: "Pojištění řešíme exkluzivně s Allianz. U investic a úvěrů vybíráme ty nejlepší nabídky ze všech bank na trhu.",
      en: "For insurance, we work exclusively with Allianz. For investments and loans, we pick the best offers from every bank on the market.",
    },
    insuranceLabel: { cs: "Exkluzivní pojistný partner", en: "Exclusive Insurance Partner" },
    banksLabel: { cs: "Banky a finanční instituce", en: "Banks & Financial Institutions" },
    investLabel: { cs: "Investice zajišťujeme přes", en: "Investments Via" },
  },
  booking: {
    badge: { cs: "Kalendář schůzek", en: "Meeting Calendar" },
    heading: { cs: "Vyberte si termín, který vám sedí", en: "Pick a Time That Suits You" },
    subtext: {
      cs: "Zarezervujte si 30 minut s Raffaelem nebo Ondřejem. Osobně u nás v České Lípě nebo online. Každá schůzka je vždy zdarma a k ničemu vás nezavazuje.",
      en: "Book 30 minutes with Raffaele or Ondřej. In person at our Česká Lípa office or online. Every meeting is always free and completely no-strings-attached.",
    },
    stepAdvisor: { cs: "1. S kým si chcete popovídat?", en: "1. Who would you like to meet?" },
    stepWhen: { cs: "2. Vyberte datum a čas", en: "2. Pick a date and time" },
    stepMode: { cs: "3. Jak se potkáme?", en: "3. How shall we meet?" },
    stepDetails: { cs: "4. Kam pošleme potvrzení?", en: "4. Where do we send the confirmation?" },
    modes: {
      office: { cs: "V kanceláři", en: "At our office" },
      visit: { cs: "Přijeďte za mnou", en: "Come to me" },
      online: { cs: "Online", en: "Online" },
    },
    advisorBoth: { cs: "Je mi to jedno", en: "Either works" },
    pickTime: { cs: "Nejdřív vyberte datum", en: "Pick a date first" },
    name: { cs: "Jméno a příjmení", en: "Full Name" },
    namePh: { cs: "Jan Novák", en: "John Smith" },
    email: { cs: "E-mail", en: "Email" },
    emailPh: { cs: "jan@priklad.cz", en: "john@example.com" },
    phone: { cs: "Telefon", en: "Phone" },
    phonePh: { cs: "+420 777 123 456", en: "+420 777 123 456" },
    topic: { cs: "Co chcete probrat? (nepovinné)", en: "What would you like to discuss? (optional)" },
    topicPh: { cs: "Např. kontrola životního pojištění…", en: "E.g. reviewing my life insurance…" },
    submit: { cs: "Potvrdit rezervaci", en: "Confirm Booking" },
    sending: { cs: "Rezervuji…", en: "Booking…" },
    missingSlot: {
      cs: "Vyberte prosím datum a čas schůzky.",
      en: "Please pick a date and time for the meeting.",
    },
    successTitle: { cs: "Schůzka rezervována", en: "Meeting Booked" },
    successMsg: {
      cs: "Těšíme se na vás! Potvrzení pošleme na váš e-mail.",
      en: "Looking forward to meeting you! We'll email you a confirmation.",
    },
    errorMsg: {
      cs: "Rezervace se nepovedla. Zkuste to prosím znovu.",
      en: "Booking failed. Please try again.",
    },
    captchaMissing: { cs: "Opište prosím kód z obrázku", en: "Please type the code from the image" },
    captchaWrong: { cs: "Kód z obrázku nesouhlasí — zkuste to znovu.", en: "The code doesn't match — please try again." },
    gdpr: {
      cs: "Odesláním souhlasíte se zpracováním údajů za účelem domluvení schůzky.",
      en: "By submitting, you consent to your data being used to arrange the meeting.",
    },
    duration: { cs: "30 minut", en: "30 minutes" },
    modeLabel: { cs: "Kancelář · u vás · online", en: "Office · your place · online" },
  },
  footer: {
    tagline: {
      cs: "Pojištění a finance lidsky. Dva parťáci, jedna káva a férové rady.",
      en: "Insurance and finance, human-style. Two partners, one coffee, honest advice.",
    },
    contactTitle: { cs: "Kontakt", en: "Contact" },
    teamTitle: { cs: "Vaši poradci", en: "Your Advisors" },
    address: { cs: "Hrnčířská 2456, 470 01 Česká Lípa 1", en: "Hrnčířská 2456, 470 01 Česká Lípa 1" },
    linksTitle: { cs: "Navigace", en: "Navigation" },
    legalTitle: { cs: "Právní informace", en: "Legal" },
    privacy: { cs: "Ochrana osobních údajů", en: "Privacy Policy" },
    terms: { cs: "Obchodní podmínky", en: "Terms of Service" },
    disclaimer: {
      cs: "Zirsen je společná značka samostatně podnikajících finančních poradců Raffaelea Zironeho (IČO: 11746858) a Ondřeje Šenfelda (IČO: 19739842). V oblasti pojištění jednáme jako vázaní zástupci Allianz pojišťovny, a. s. Investice nejsou vklady a jejich hodnota může kolísat.",
      en: "Zirsen is the joint brand of independent financial advisors Raffaele Zirone (Business ID: 11746858) and Ondřej Šenfeld (Business ID: 19739842). In insurance, we act as tied agents of Allianz pojišťovna, a.s. Investments are not deposits and their value may fluctuate.",
    },
    rights: { cs: "© 2026 Zirsen. Všechna práva vyhrazena.", en: "© 2026 Zirsen. All rights reserved." },
  },
  faq: {
    kicker: { cs: "Časté dotazy", en: "FAQ" },
    heading: { cs: "Na co se nás ptáte", en: "What People Ask Us" },
    subtext: {
      cs: "Nejčastější otázky, které nám klienti kladou. Kdybyste tu svoji nenašli, ozvěte se — odpovíme osobně.",
      en: "The questions clients ask us most. If you can't find yours here, get in touch — we'll answer personally.",
    },
    items: [
      {
        q: { cs: "Vyplatí se mi refinancování hypotéky?", en: "Is refinancing my mortgage worth it?" },
        a: {
          cs: "Často ano. Porovnáme vaši současnou sazbu s nabídkami všech bank na trhu a spočítáme, kolik byste ušetřili. A když se to nevyplatí, řekneme vám to na rovinu.",
          en: "Often yes. We compare your current rate against offers from every bank on the market and calculate how much you'd save. And if it doesn't pay off, we tell you straight.",
        },
      },
      {
        q: { cs: "Co je Finanční analýza a co mi přinese?", en: "What is the Financial Analysis and what do I get?" },
        a: {
          cs: "Náš vlastní online nástroj, který za 60 sekund vyhodnotí 5 pilířů vašich financí — od pojištění přes rezervy a investice až po hypotéku. Výsledek vidíte okamžitě a přijde vám i e-mailem, abychom ho mohli spolu probrat.",
          en: "Our own online tool that evaluates the 5 pillars of your finances in 60 seconds — from insurance and reserves to investments and your mortgage. You see the result instantly and receive it by email so we can go through it together.",
        },
      },
      {
        q: { cs: "Pomůžete mi se zajištěním na důchod?", en: "Will you help me with retirement planning?" },
        a: {
          cs: "Ano. Spočítáme, kolik vám bude v důchodu chybět, a sestavíme plán na míru — od penzijního připojištění přes dlouhodobé spoření po investice.",
          en: "Yes. We calculate how much you'll be short in retirement and build a tailored plan — from pension savings through long-term saving to investments.",
        },
      },
      {
        q: { cs: "S kým vlastně spolupracujete?", en: "Who do you actually work with?" },
        a: {
          cs: "U pojištění spolupracujeme exkluzivně s Allianz. U hypoték a úvěrů porovnáváme nabídky všech bank na trhu a u investic vybíráme z více než 19 institucí — vždy podle toho, co dává smysl pro vás.",
          en: "For insurance we work exclusively with Allianz. For mortgages and loans we compare offers from every bank on the market, and for investments we pick from 19+ institutions — always based on what makes sense for you.",
        },
      },
      {
        q: { cs: "Už mám pojištění nebo hypotéku sjednané. Má smysl se ozvat?", en: "I already have insurance or a mortgage. Is it worth getting in touch?" },
        a: {
          cs: "Právě že ano. Stávající smlouvy zdarma zkontrolujeme, ukážeme, kde platíte zbytečně moc nebo kde vám chybí krytí, a u hypotéky umíme vyjednat lepší sazbu při refinancování.",
          en: "Absolutely. We review your existing contracts for free, show where you overpay or lack coverage, and for mortgages we can negotiate a better rate through refinancing.",
        },
      },
      {
        q: { cs: "Čím se lišíte od běžného finančního poradce?", en: "How are you different from a typical financial advisor?" },
        a: {
          cs: "Jsme dva partneři, ne call centrum. Žádný prodejní tlak — místo prodeje produktů stavíme dlouhodobý plán na míru a vysvětlujeme vše lidsky a srozumitelně.",
          en: "We're two partners, not a call centre. No sales pressure — instead of pushing products we build a long-term tailored plan and explain everything in plain human language.",
        },
      },
      {
        q: { cs: "Kdo je Zirsen?", en: "Who is Zirsen?" },
        a: {
          cs: "Zirsen jsme dva partneři z České Lípy — Raffaele Zirone a Ondřej Šenfeld. Pracujeme jako samostatní finanční poradci pod společnou značkou, takže vždy víte, s kým jednáte.",
          en: "Zirsen is two partners from Česká Lípa — Raffaele Zirone and Ondřej Šenfeld. We work as independent financial advisors under one shared brand, so you always know who you're dealing with.",
        },
      },
      {
        q: { cs: "Řešíte i povinné ručení a pojištění auta?", en: "Do you also handle car insurance and mandatory liability?" },
        a: {
          cs: "Ano. Pojištění vozidel včetně povinného ručení sjednáváme s Allianz a nastavíme ho podle toho, jak auto skutečně používáte.",
          en: "Yes. Vehicle insurance, including mandatory liability, is arranged with Allianz and tailored to how you actually use your car.",
        },
      },
      {
        q: { cs: "Pomáháte i firmám a podnikatelům?", en: "Do you also help businesses and entrepreneurs?" },
        a: {
          cs: "Ano. Kromě osobního pojištění řešíme i pojištění firem a podnikatelů — od majetku a odpovědnosti po zaměstnance.",
          en: "Yes. Besides personal insurance we also cover businesses and entrepreneurs — from property and liability to employees.",
        },
      },
      {
        q: { cs: "Jak vybíráte investice?", en: "How do you pick investments?" },
        a: {
          cs: "Vybíráme z více než 19 institucí na trhu. Nejprve spolu nastavíme finanční rezervu, potom dlouhodobé spoření a případně odvážnější investice — vždy podle vaší situace a tolerance k riziku.",
          en: "We pick from 19+ institutions on the market. First we set up your safety net together, then long-term saving and possibly bolder investments — always based on your situation and risk tolerance.",
        },
      },
      {
        q: { cs: "Co si mám na schůzku připravit?", en: "What should I prepare for the meeting?" },
        a: {
          cs: "Nic nemusíte. Stačí přijít s tím, co vás trápí. Pokud už máte nějaké smlouvy (pojištění, hypotéka, spoření), vezměte je s sebou — projdeme je spolu.",
          en: "Nothing at all. Just bring what's on your mind. If you already have contracts (insurance, mortgage, savings), bring them along — we'll go through them together.",
        },
      },
      {
        q: { cs: "Působíte jen v České Lípě?", en: "Do you only work in Česká Lípa?" },
        a: {
          cs: "Kancelář máme v České Lípě, ale pracujeme po celé ČR — můžeme přijet za vámi, nebo se potkat online.",
          en: "Our office is in Česká Lípa, but we work across all of Czechia — we can come to you or meet online.",
        },
      },
      {
        q: { cs: "Kolik za vaše služby zaplatím?", en: "How much do your services cost?" },
        a: {
          cs: "Všechny schůzky i Finanční analýza jsou vždy zdarma a nezávazné. Pokud budeme pokračovat dál, vždy předem otevřeně vysvětlíme, jak spolupráce funguje.",
          en: "All meetings and the Financial Analysis are always free with no strings attached. If we continue working together, we always explain openly upfront how the cooperation works.",
        },
      },
    ],
    contactCta: { cs: "Nenašli jste odpověď? Napište nám", en: "Didn't find your answer? Write to us" },
  },
};
